import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TopBar from "../../../components/TopBarComponent/Topbar";
import Button from "../../../components/ButtonComponent/Button";
import UploadIcon from "../../../assets/images/Icons/uploadIcon.svg";
import CameraIcon from "../../../assets/images/Icons/cameraIcon.svg";
import { EmployeeRegistrationContext } from "../EmployeeRegistartionView";
import "./employeeRegistration.css";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
import TextInput from "../../../components/TextInputComponent/TextInput";
import CameraUpload from "../../../components/CameraUpLoadComponent/CameraUpload";
import { number } from "prop-types";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import EmployeeAlert from "../../../components/EmployeeAlert/EmployeeAlert";
import CalenderIcon from "../../../assets/images/calenderIcon.svg";
import IconProfile from "../../../assets/images/Icons/profileIcon.svg";
import DatePicker from "react-multi-date-picker";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import moment from "moment";
const EmployeeRegistration = ({ textContants }) => {
  const {
    employeeProfile,
    goBack,
    category,
    setCategory,
    fullName,
    setFullName,
    employeeCode,
    setEmployeeCode,
    birthDate,
    setBirthDate,
    email,
    setEmail,
    emergencyContactNo,
    setEmergencyContactNo,
    ertRole,
    setErtRole,
    addPhoto,
    setAddPhoto,
    idProof,
    setIdProof,
    statusCode,
    workingUnit,
    setWorkingUnit,
    section,
    setSection,
    punchingId,
    setPunchingId,
    magneticId,
    setMagneticId,
    contactNo,
    setContactNo,
    fullNameRequired,
    setFullNameRequired,
    employeeCodeRequired,
    setEmployeeCodeRequired,
    birthDateRequired,
    setBirthDateRequired,
    emailRequired,
    setEmailRequired,
    emergencyContactNoRequired,
    setEmergencyContactNoRequired,
    ertRoleRequired,
    setErtRoleRequired,
    addPhotoRequired,
    setAddPhotoRequired,
    IdProofRequired,
    setIdProofRequired,
    workingUnitRequired,
    setWorkingUnitRequired,
    sectionRequired,
    setSectionRequired,
    punchingIdRequired,
    setPunchingIdRequired,
    magneticIdRequired,
    setMagneticIdRequired,
    contactNoRequired,
    setContactNoRequired,
    categoryRequiredData,
    setCategoryRequiredData,
    isCamera,
    setIsCamera,
    show,
    setShow,
    handleShow,
    setHandleShow,
    isWbCamEnabled,
    setIsWbCamEnabled,
    modalOpenStatus,
    setModalOpenStatus,
    categoryListDropDown,
    showAlert,
    setShowAlert,
    alertMessage,
    categoryIdSelected,
    setcategoryIdSelected,
    navigateToEmployeeMaster,
    displayName,
    isEdit,
    callEditEmployeeApi,
    employeeId,
    setEmployeeId,
    dobDate,
    setDobDate,
    fromDate,
    setFromDate,
    validDates,
    ertList,
    setErtList,
    invalidEmail,
    setInvalidEmail,
    photoLabel,
    pdfFileLabel,
    setPhotoLabel,
    setPdfFileLabel,
    initialBdate,
    showImagePreview,
    setShowImagePreview,
    entryType,
    setEmployeeEntryType,
    groupExcelRequired,
    setGroupExcelRequired,
    groupExcelFile,
    setGroupExcelFile,
    groupExcelFileLabel,
    setGroupExcelFileLabel,
    submitData,
    empAlert,
    logout,
    successMessage,
    failedMessage,
    setEmpAlert,
    failedMessageData,
    employeeSpinnerStatus,
    onSubmitCloseAlert, // Alert closing function
  } = useContext(EmployeeRegistrationContext);
  const imageUpload = (e) => {
    const file = e.target.files[0];
    getBase64(file).then((base64) => {
      localStorage["fileBase64"] = base64;
      console.debug("file stored", base64);
    });
    setAddPhoto(file);
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleImageUpload = (imageToUpload) => {
    setAddPhoto(imageToUpload);
  };

  const imgPath = photoLabel ? `${baseURL}/images/${photoLabel} ` : IconProfile;
  return (
    <div>
      <TopBar />
      <Container>
        <div className="registration-container mt-4">
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column">
              <div className="py-2">
                <p className="register-title">
                  {displayName || "Employee Register"}
                </p>
              </div>
              {isEdit ? null : (
                <div className="checkContainerEmployeeRegister">
                  <div
                    className="checkIndividualEmployeeRegister cursor-pointer"
                    onClick={() => {
                      setEmployeeEntryType();
                    }}
                  >
                    {entryType == "I" ? (
                      <div className="checkInEmployeeRegister"></div>
                    ) : null}
                  </div>
                  <span
                    className="individualTextEmployeeRegister"
                    onClick={() => {
                      setEmployeeEntryType();
                    }}
                  >
                    {"Individual"}
                  </span>
                  <div
                    className="checkGroupEmployeeRegister"
                    onClick={() => {
                      setEmployeeEntryType();
                    }}
                  >
                    {entryType == "G" ? (
                      <div className="checkInEmployeeRegister"></div>
                    ) : null}
                  </div>
                  <span
                    className="individualTextEmployeeRegister"
                    onClick={() => {
                      setEmployeeEntryType();
                    }}
                  >
                    {"Group"}
                  </span>
                </div>
              )}
            </div>

            {isEdit ? (
              <div className="p-2">
                <img
                  className="previewImag"
                  src={imgPath}
                  width="35px"
                  height="40px"
                />
              </div>
            ) : (
              ""
            )}
          </div>
          {entryType === "I" ? (
            <Row className="individual-entry">
              <Col lg={4}>
                <Row>
                  <Col lg={4}>
                    <label>{textContants.empFullName}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={fullNameRequired == false ? "error" : null}
                  >
                    <TextInput
                      placeholder={fullName}
                      value={fullName}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/^ |[^a-zA-Z\s]/g, "");
                        setFullName(value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4} className="item-padding">
                    <label>{textContants.employeeCode}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={employeeCodeRequired == false ? "error" : null}
                  >
                    <TextInput
                      className="employee-code"
                      placeholder={employeeCode}
                      value={employeeCode}
                      type={"number"}
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-", "."].includes(e.key) &&
                        e.preventDefault()
                      }
                      onChange={(e) => {
                        setEmployeeCode(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4 dropdownCategoryListData">
                  <Col lg={4}>
                    <label>{textContants.category}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={categoryRequiredData == false ? "error" : null}
                  >
                    <DropDownItem
                      selectedItem={category}
                      setSelectedItem={setCategory}
                      list={categoryListDropDown}
                      categoryRequired={categoryRequiredData}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.dObEmp}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={birthDateRequired == false ? "error" : null}
                  >
                    <DatePicker
                      showOtherDays
                      className="date-picker"
                      value={initialBdate}
                      render={(value, openCalendar) => {
                        console.log("value", value, birthDate);
                        console.log("initialBdate", initialBdate);
                        return (
                          <div onClick={openCalendar}>
                            <div
                              className={
                                validDates
                                  ? "dobContainerBox"
                                  : "dobContainerBox not-valid"
                              }
                            >
                              <div className="dateOfBirthBox">
                                <span className="selectTextReportBox">
                                  {birthDate ? birthDate : "Select Date"}
                                  {value ? setBirthDate(value) : null}
                                </span>
                              </div>
                              <div className="calenderReportBox">
                                <img src={CalenderIcon} />
                              </div>
                            </div>
                          </div>
                        );
                      }}
                      maxDate={moment().format("YYYY-MM-DD")}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.emailAddress}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={emailRequired == false ? "error" : null}
                  >
                    <TextInput
                      placeholder={email}
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        //setEmail(e.target.value);
                      }}
                    />
                    {invalidEmail ? (
                      <div className="invalid-textMsg">
                        {textContants.emailWarning}
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Col>
              <Col lg={4}>
                <Row>
                  <Col
                    lg={4}
                    className={workingUnitRequired == false ? "error" : null}
                  >
                    <label>{textContants.workingUnit}</label>
                  </Col>
                  <Col lg={8}>
                    <TextInput
                      placeholder={workingUnit}
                      value={workingUnit}
                      onChange={(e) => {
                        setWorkingUnit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.section}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={sectionRequired == false ? "error" : null}
                  >
                    <TextInput
                      placeholder={section}
                      value={section}
                      onChange={(e) => {
                        setSection(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.punchingID}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={punchingIdRequired == false ? "error" : null}
                  >
                    <TextInput
                      placeholder={punchingId}
                      value={punchingId}
                      type="number"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-", "."].includes(e.key) &&
                        e.preventDefault()
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      onChange={(e) => {
                        setPunchingId(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.magneticCardID}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={magneticIdRequired == false ? "error" : null}
                  >
                    <TextInput
                      placeholder={magneticId}
                      value={magneticId}
                      type="number"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-", "."].includes(e.key) &&
                        e.preventDefault()
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      onChange={(e) => {
                        setMagneticId(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.contactNo}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={contactNoRequired == false ? "error" : null}
                  >
                    <TextInput
                      placeholder={contactNo}
                      value={contactNo}
                      type={"number"}
                      maxLength={10}
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-", "."].includes(e.key) &&
                        e.preventDefault()
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      onChange={(e) => {
                        setContactNo(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg={4}>
                <Row>
                  <Col lg={4}>
                    <label>{textContants.supervisorContactno}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={
                      emergencyContactNoRequired == false ? "error" : null
                    }
                  >
                    <TextInput
                      placeholder={emergencyContactNo}
                      value={emergencyContactNo}
                      type="number"
                      maxLength={10}
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-", "."].includes(e.key) &&
                        e.preventDefault()
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      onChange={(e) => {
                        setEmergencyContactNo(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4} className="item-padding">
                    <label>{textContants.eRTRole}</label>
                  </Col>
                  <Col
                    lg={8}
                    className={ertRoleRequired == false ? "error" : null}
                  >
                    <DropDownItem
                      selectedItem={ertRole}
                      setSelectedItem={setErtRole}
                      list={ertList}
                      categoryRequired={ertRoleRequired}
                    />
                    {/* <TextInput
                    placeholder={ertRole}
                    value={ertRole}
                    onChange={(e) => {
                      let value = e.target.value;

                      setErtRole(value);
                    }}
                  /> */}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>{<label>{textContants.addPhoto}</label>}</Col>
                  <Col lg={8}>
                    <Row>
                      <Col lg={6} className="uploadCameraPhoto">
                        <label
                          className={
                            addPhotoRequired == false
                              ? "upload-button error-upload"
                              : "upload-button"
                          }
                        >
                          <img src={UploadIcon} alt="img" />
                          <span className="text-margin">
                            {textContants.upload}
                          </span>
                          <input
                            className="default-btn"
                            type="file"
                            accept="image/jpeg, image/png, application/pdf"
                            onChange={(e) => {
                              let selectedFile = e.target.files[0];
                              const acceptedFiles = [
                                "image/png",
                                "image/jpeg",
                                "image/jpg",
                                "application/pdf",
                              ];
                              if (
                                selectedFile &&
                                acceptedFiles.indexOf(selectedFile.type) === -1
                              ) {
                                setAddPhoto(false);
                                setPhotoLabel("");
                              } else {
                                setPhotoLabel(e?.target?.files[0]?.name);
                                setAddPhoto(e?.target?.files[0]);
                                setShowImagePreview(
                                  URL.createObjectURL(e.target.files[0])
                                );
                              }
                            }}
                          />
                          {isEdit ? (
                            <img
                              className="previewImagEmployee"
                              src={showImagePreview}
                              width="35px"
                              height="40px"
                            />
                          ) : (
                            ""
                          )}
                        </label>
                      </Col>

                      {/* <Col lg={6} className="btn-margin-top">
                      <label
                        className={
                          addPhotoRequired == false
                            ? "upload-button error-upload"
                            : "upload-button"
                        }
                      >
                        <img src={CameraIcon} alt="img" />
                        <span className="text-margin">
                          {textContants.camera}
                        </span>

                        <input
                          className="default-btn"
                          type="button"
                          onClick={() => {
                            // setShow(true);
                            setModalOpenStatus(true);
                          }}
                        />
                      </label>
                    </Col> */}
                      <Col lg={12} className="image-name">
                        <p className="upload-label">{photoLabel}</p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={4}>
                    <label>{textContants.uploadIDProof}</label>
                  </Col>
                  <Col lg={8}>
                    <label
                      className={
                        IdProofRequired === false
                          ? "upload-button error-upload"
                          : "upload-button"
                      }
                    >
                      <img src={UploadIcon} alt="img" />
                      <span className="text-margin">{textContants.upload}</span>
                      <input
                        className="default-btn"
                        type="file"
                        accept="image/jpeg, image/png, application/pdf"
                        onChange={(e) => {
                          let selectedFile = e.target.files[0];
                          const acceptedFiles = [
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ];
                          if (
                            selectedFile &&
                            acceptedFiles.indexOf(selectedFile.type) === -1
                          ) {
                            setIdProof(false);
                            setPdfFileLabel("");
                          } else {
                            setPdfFileLabel(e.target.files[0]?.name);
                            setIdProof(e.target.files[0]);
                          }
                        }}
                      />
                    </label>
                    <p className="format-msg upload-label">
                      {pdfFileLabel
                        ? pdfFileLabel
                        : "Invalid. Please select JPG, PNG or PDF."}
                    </p>
                    {/* <div
                    className={
                      IdProofRequired == false
                        ? "error-upload proof-btn-box"
                        : "proof-btn-box"
                    }
                  >
                     <div className="button-center"> 
                      <label className="upload-button-yellow">
                        <img src={UploadIcon} alt="img" />
                        <span className="text-margin">
                          {textContants.upload}
                        </span>
                        <input
                          className="default-btn"
                          type="file"
                          accept="image/jpeg, image/png, application/pdf"
                          onChange={(e) => {
                            let selectedFile = e.target.files[0];
                            const acceptedFiles = [
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ];
                            if (
                              selectedFile &&
                              acceptedFiles.indexOf(selectedFile.type) === -1
                            ) {
                              setIdProof(
                                "Invalid File Type. Please select JPG, PNG or PDF Files"
                              );
                            } else {
                              setPdfFileLabel(e.target.files[0]?.name);
                              setIdProof(e.target.files[0]);
                            }
                          }}
                        />
                      </label>
                     </div> 
                    {idProof == "" ? (
                      <p className="format-msg">PNG, JPEG, PDF Format</p>
                    ) : (
                      <p className="format-msg">{pdfFileLabel}</p>
                    )}
                  </div> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <div className="group-entry">
              <Row className="d-flex justify-content-start">
                <Col lg={4}>
                  <label>Upload Excel*</label>
                </Col>
                <Col className="upload-excel-button" lg={4}>
                  <label
                    className={
                      groupExcelRequired === false
                        ? "upload-button error-upload"
                        : "upload-button"
                    }
                  >
                    <img src={UploadIcon} alt="img" />
                    <span className="text-margin">{textContants.upload}</span>
                    <input
                      className="default-btn"
                      type="file"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      onChange={(e) => {
                        let selectedFile = e.target.files[0];
                        const acceptedFiles = [
                          ".csv",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          "application/vnd.ms-excel",
                        ];
                        if (
                          selectedFile &&
                          acceptedFiles.indexOf(selectedFile.type) === -1
                        ) {
                          setGroupExcelFileLabel(
                            "Invalid File Type. Please select an Excel File"
                          );
                        } else {
                          setGroupExcelFileLabel(e.target.files[0]?.name);
                          setGroupExcelFile(e.target.files[0]);
                        }
                      }}
                    />
                  </label>
                  <p className="imageNameGuest">{groupExcelFileLabel}</p>
                </Col>
              </Row>
            </div>
          )}
          <Row>
            <div className="button-box">
              <Row>
                <Col className="cancelEmp-btn">
                  <Button text={textContants.cancel} onClick={() => goBack()} />
                </Col>
                <Col>
                  <Button
                    text={
                      employeeSpinnerStatus ? (
                        <Spinner size="sm" />
                      ) : (
                        textContants.save
                      )
                    }
                    onClick={() => {
                      submitData();
                    }}
                  />
                </Col>
              </Row>
              <EmployeeAlert
                showData={empAlert}
                setShowData={setEmpAlert}
                successMessage={successMessage}
                failedMessage={failedMessage}
                errorMessageData={failedMessageData}
                handleSubmitData={() => goBack()}
              />
            </div>
          </Row>
        </div>
      </Container>
      <CameraUpload
        show={modalOpenStatus}
        setShow={setModalOpenStatus}
        isCamera={isCamera}
        setIsCamera={setIsCamera}
        isWbCamEnabled={isWbCamEnabled}
        setWebCamEnabled={setIsWbCamEnabled}
        setVisitorPhoto={setAddPhoto}
      />
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => onSubmitCloseAlert()
        }
      />
    </div>
  );
};

export default EmployeeRegistration;
